/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts"/>

declare var irep: IREP.IREP;

namespace IREP {
    "use strict";

    export class ContactUs  {

   
        constructor(options:any) {

                var submitButton, failureMessage, successMessage, successMessage2, txtMessage, missingMessage, txtFirstName, txtLastName, txtEmail, emailSupport, isAuthenticated, txtCountry, isAnonymous;
                var init = function (options) {
                    submitButton = options.submitButton;
                    failureMessage = options.failureMessage;
                    successMessage = options.successMessage;
                    successMessage2 = options.successMessage2;
                    txtMessage = options.txtMessage;
                    emailSupport = options.emailSupport;
                    missingMessage = options.missingMessage;
                    txtFirstName = options.txtFirstName;
                    txtLastName = options.txtLastName;
                    txtEmail = options.txtEmail;
                    txtCountry = options.txtCountry;
                    isAnonymous = options.isAnonymous.toLowerCase();


                    $(submitButton).click(function () {
                        $('#divMessage').html('');
                        if (validateForm()) {
                            var objContactUs =
                                {
                                    FirstName: irep.options.user.firstName,
                                    LastName: irep.options.user.lastName,
                                    Email: irep.options.user.email,
                                    StoreCode: irep.options.user.storeCode,
                                    StoreChainName: irep.options.user.storeChainName,
                                    UserType: irep.options.user.userType,
                                    UserTypeId: irep.options.user.userTypeId,
                                    GeoCode: irep.options.user.geoCode,
                                    CultureCode: irep.options.user.cultureCode,
                                    EmailSupport: emailSupport,
                                    CountryCode: irep.options.user.countryCode,
                                    StoreChainId: irep.options.user.storeChainId,
                                    Site: irep.options.user.site,
                                    Language: "en-US", 
                                    Message: ""
                                };

                            //non-authenticated users
                            if (irep.options.user.email === undefined) {
                                objContactUs.FirstName = $(txtFirstName).val();
                                objContactUs.LastName = $(txtLastName).val();
                                objContactUs.Email = $(txtEmail).val();
                                objContactUs.GeoCode = irep.options.user.geoCode;
                                objContactUs.Language = irep.options.user.cultureCode;
                                objContactUs.UserType = "";
                                objContactUs.EmailSupport = "";
                                objContactUs.CountryCode = $(txtCountry).val();
                                objContactUs.Site = irep.options.user.site;
                            }

                            objContactUs.Message = $.trim($(txtMessage).val());
                            clearMessage();
                            if (objContactUs.Message !== "") {
                                //block($(".contact-us-wrapper"));

                                $.ajax({
                                    type: "post",
                                    dataType: "html",
                                    url: irep.options.appUrl + "/" + irep.options.user.site + "/contactusPost",
                                    //Serializes all parts of the form including the anti-forgery token. 
                                    //Concatenate the sub-form. Kinda hack-ish. But it works. 
                                    data: { cc: objContactUs, isAnonymous: isAnonymous }
                                }).done(function (data) {
                                    if (successMessage2.indexOf("&lt;sup&gt;&amp;reg&lt;/sup&gt;") > -1) {
                                        successMessage2 = successMessage2.replace("&lt;sup&gt;&amp;reg&lt;/sup&gt;", "<sup>®</sup>");
                                    }
                                    $("#divMessage").html('<div class="contact-us-success margin-bottom--small"><div class="messageIcon"> </div> <span>' + successMessage + '</span></div>');
                                    $(".contact-us-success").css("display","flex");
                                    $(window).scrollTop(0);
                                    $(txtMessage).val('');
                                    //$('#divMessage').css("color", "white"); //reset in case of failure from multiple submits
                                    //hideForm();
                                    //($(".contact-us-wrapper")).unblock();
                                    }).fail(function (data, e) {
                                        $("#divMessage").html(' <div class="contact-us-fail margin-bottom--small"><div class="messageIcon"></div><span>' + failureMessage + '</span></div>');
                                        $(".contact-us-fail").css("display", "flex");
                                    //($(".contact-us-wrapper")).unblock();
                                });

                            }
                        }
                        return false;
                    });

                  

                };

                var validateForm = function () {
                    var isValid = true;
                    $(".contact-us-error").hide();
                    $(".errorBorder").removeClass("errorBorder");
                    if (irep.options.user.email === undefined) {

                        // validate first name (required)
                        var firstName = $.trim($(txtFirstName).val());
                        if (firstName === "") {
                            $(txtFirstName + "Required").show();
                            $(txtFirstName).addClass("errorBorder");
                            isValid = false;
                        }

                        // validate last name (required)
                        var lastName = $.trim($(txtLastName).val());
                        if (lastName === "") {
                            $(txtLastName + "Required").show();
                            $(txtLastName).addClass("errorBorder");
                            isValid = false;
                        }

                        // validate email (required, regex)
                        var email = $.trim($(txtEmail).val());
                        if (email === "") {
                            $(txtEmail + "Required").show();
                            $(txtEmail).addClass("errorBorder");
                            isValid = false;
                        } else if (!(/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email))) {
                            $(txtEmail + "Format").show();
                            $(txtEmail).addClass("errorBorder");
                            isValid = false;
                        }
                    }

                    // validate message (required)
                    var message = $.trim($(txtMessage).val());
                    if (message === "") {
                        $(txtMessage + "Required").show();
                        $(txtMessage).addClass("errorBorder");
                        isValid = false;
                    }

                    return isValid;
                };

               

                var clearMessage = function () {
                    $("#divMessage").html('');
                };



            init(options);
        }
    }
}